import React from 'react';
import {Skeleton, Stack} from '@mui/material';

export function RefundStatusLoadingState() {
	return (
		<Stack gap={2} mt={1}>
			<Skeleton variant="rectangular" height={26} />
			<Stack gap={1}>
				<Skeleton variant="rectangular" width={148} height={18} />
				<Skeleton variant="rectangular" width={98} height={18} />
			</Stack>
			<Stack gap={1}>
				<Skeleton variant="rectangular" width={214} height={18} />
				<Skeleton variant="rectangular" width={146} height={18} />
			</Stack>
			<Stack gap={1} mt={2}>
				<Skeleton variant="rectangular" width={214} height={18} />
				<Skeleton variant="rectangular" width={146} height={18} />
			</Stack>
		</Stack>
	);
}
